import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  useTheme,
} from "@mui/material";
import logo1 from "./img/companyCardLogo1.png";
import logo2 from "./img/companyCardLogo2.png";
import logo3 from "./img/companyCardLogo3.png";

const companies = [
  {
    name: "Cosco",
    logo: logo1,
    category: "Sports Equipment Brand",
    description:
      "How Cosco, one of the most renowned Sporting equipment companies used AiSensy to drive ",
    highlight: "3x more conversions.",
  },
  {
    name: "Give",
    logo: logo2,
    category: "Donation Collection Platform",
    description:
      "Discover how Give, India's most trusted donations collection platform used WhatsApp to achieve a ",
    highlight: "90% Payment success rate & 15X ROI.",
  },
  {
    name: "PhysicsWallah",
    logo: logo3,
    category: "Edtech Platform",
    description:
      "Check out how PhysicsWallah, an Edtech giant used AiSensy to drive ",
    highlight: "3x more Leads through WhatsApp via AiSensy.",
  },
];

const CompanyCards = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontWeight: 700,
            mb: 6,
            fontSize: { xs: 30, md: 39 },
            color: "#111",
          }}
        >
          How Brands use VertexSuite for{" "}
          <span style={{ color: "#00D084" }}>WhatsApp</span> Marketing
        </Typography>

        <Grid container spacing={4}>
          {companies.map((company, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={0}
                sx={{
                  border: "1px solid #eee",
                  borderRadius: 4,
                  height: "100%",
                  minHeight: 360, // Slightly increased height
                  p: 3, // More padding
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  "&:hover": {
                    boxShadow: theme.shadows[6],
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      mb: 2,
                      transition: "transform 0.3s ease",
                      "& img": {
                        width: 115, // Slightly bigger logos
                        height: "auto",
                        transition: "transform 0.3s ease",
                      },
                      "&:hover img": {
                        transform: "scale(1.1)",
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={company.logo}
                      alt={company.name}
                    />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1 }}
                  >
                    {company.category}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#444" }}>
                    {company.description}
                    <Box
                      component="span"
                      sx={{ fontWeight: 600, color: "#00C851" }}
                    >
                      {company.highlight}
                    </Box>
                  </Typography>
                </CardContent>
                <Box sx={{ px: 2, pb: 2, mt: 2 }}>
                  <Button
                    variant="outlined"
                    fullWidth
                    endIcon={
                      <span style={{ fontWeight: "600", color: "#000" }}>
                        →
                      </span>
                    }
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      borderColor: "#000",
                      color: "#000",
                      backgroundColor: "#fff",
                      py: 1.2,
                      borderRadius: 2,
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        borderColor: "#000",
                      },
                    }}
                  >
                    Explore Case Study
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CompanyCards;
